// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f79e3302da6a29a999a4e3453d633f0bae436491/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};